






































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import WorkshopsBookingDetails from "../workshops/WorkshopsBookingDetails.vue";

import WorkshopJson from "../../shared/WorkshopJson";
import WorkshopBookingJson from "../../shared/WorkshopBookingJson";
import { WorkshopWithBookingsJson } from "../../shared/WorkshopJson";
import { WorkshopWithBookingJson } from "../../shared/WorkshopJson";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

export default Vue.extend({
  name: "WorkshopsAll",
  components: {
    Loading,
    TableView,
    WorkshopsBookingDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
    WorkshopsBookingStatusNames: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      showDetails: false,
      detailsMode: "read",
      allWorkshops: null as WorkshopJson[] | null,
      selectedWorkshopWithBookings: null as WorkshopWithBookingsJson | null,
      selectedWorkshopId: null as number | null,
      selectedWorkshopBookingId: null as number | null,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    /*** START: details view ***/
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.reloadData();
      }
    },

    openDetails(item: WorkshopWithBookingJson | null, mode: string) {
      if (this.selectedWorkshopId != null) {
        if (item != null) {
          this.selectedWorkshopBookingId = item.ID;
        } else {
          this.selectedWorkshopBookingId = null;
        }

        this.detailsMode = mode;
        this.toggleDetails();
      } else {
        alert("Es muss zuerst ein Programm ausgewählt werden.");
      }
    },
    /*** END: details view ***/

    loadData() {
      this.loadAllWorkshops();
    },

    async loadAllWorkshops() {
      this.allWorkshops = null;
      this.selectedWorkshopId = null;
      this.selectedWorkshopBookingId = null;
      this.selectedWorkshopWithBookings = null;

      if (this.restClient != null) {
        try {
          this.allWorkshops = await this.restClient.getWorkshops();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadSelectedWorkshopWithBookings() {
      if (this.allWorkshops != null) {
        this.selectedWorkshopWithBookings = null;

        if (this.restClient != null && this.selectedWorkshopId != null) {
          try {
            this.selectedWorkshopWithBookings = await this.restClient.getWorkshopWithBookings(this.selectedWorkshopId);
          } catch (e) {
            alert(e.message);
          }
        }
      }
    },

    async reloadData() {
      this.loadSelectedWorkshopWithBookings();
    },

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "openDetailsEdit") {
        this.openDetails(item, "edit");
      }
    },

    tableViewItemClicked(item: any) {
      this.openDetails(item, "read");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.reloadData();
      }
    },
  },
  computed: {
    permissionAbleManagement: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    workshopColumns: function (): TableViewColumnDefinitions<WorkshopBookingJson>[] {
      let vue = this;

      return [
        {
          th: "Name (Erziehungsberechtigte:r)",
          td: (i) =>
            i.customer.guardianLastName != ""
              ? i.customer.guardianLastName + ", " + i.customer.guardianFirstName
              : "--",
        },
        {
          th: "Name (Teilnehmende:r)",
          td: (i) =>
            i.customer.childLastName != "" ? i.customer.childLastName + ", " + i.customer.childFirstName : "--",
        },
        {
          th: "Angefragt",
          td: (i) => DateFormatter.formatDateTime(new Date(i.bookingDateTime)),
        },
        {
          th: "Status",
          td: (i) => vue.WorkshopsBookingStatusNames[i.state],
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<WorkshopBookingJson>[];
    },

    selectedWorkshopWithBookingsBookings(): WorkshopBookingJson[] | null {
      if (this.selectedWorkshopWithBookings == null) {
        return null;
      } else {
        return this.selectedWorkshopWithBookings.bookings;
      }
    },

    selectedWorkshopRegistrationsLeftText(): string {
      if (this.selectedWorkshopWithBookings != null) {
        const maxRegistrationCount = this.selectedWorkshopWithBookings.registrationMaximumCount;
        let registrationCount = 0;

        for (let i = 0; i < this.selectedWorkshopWithBookings.bookings.length; i++) {
          if (
            this.selectedWorkshopWithBookings.bookings[i].state != "requested" &&
            this.selectedWorkshopWithBookings.bookings[i].state != "canceled" &&
            this.selectedWorkshopWithBookings.bookings[i].state != "cancellationFeeExported" &&
            this.selectedWorkshopWithBookings.bookings[i].state != "waitingList"
          ) {
            registrationCount++;
          }
        }

        if (maxRegistrationCount === undefined) {
          return "Freie Plätze: [Fehler]";
        }

        let registrationsLeft = maxRegistrationCount - registrationCount;

        if (registrationsLeft < 0) {
          return "Bereits überbucht";
        } else if (registrationsLeft == 1) {
          return "Noch 1 freier Platz";
        } else {
          return "Noch " + registrationsLeft + " freie Plätze";
        }
      }

      return "Lade freie Plätze...";
    },

    selectedWorkshopWaitingListLeftText(): string {
      if (this.selectedWorkshopWithBookings != null) {
        const maxWaitingListCount = this.selectedWorkshopWithBookings.waitingListMaximumCount;
        let waitingListCount = 0;

        for (let i = 0; i < this.selectedWorkshopWithBookings.bookings.length; i++) {
          if (this.selectedWorkshopWithBookings.bookings[i].state == "waitingList") {
            waitingListCount++;
          }
        }

        if (maxWaitingListCount === undefined) {
          return "Warteliste: [Fehler]";
        }

        let waitingListLeft = maxWaitingListCount - waitingListCount;

        if (waitingListLeft < 0) {
          return "Warteliste: Überbucht";
        } else if (waitingListLeft == 1) {
          return "Warteliste: 1 Platz frei";
        } else {
          return "Warteliste: " + waitingListLeft + " Plätze frei";
        }
      }

      return "Lade Warteliste...";
    },
  },
});
